import React from 'react';
import { useParams } from 'next/navigation';
import { Money } from 'shared/types/product/Money';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import Typography from '../../../atoms/typography';

interface Props {
  discountedPrice?: Money;
  price?: Money;
}

const Prices: React.FC<Props> = ({ price, discountedPrice }) => {
  const { locale } = useParams();

  if (!price) return <></>;

  return (
    <>
      {discountedPrice ? (
        <div className="flex items-center gap-8">
          <Typography className="m-0 text-base leading-loose text-gray-500 line-through">
            {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
          </Typography>
          <Typography className="m-0 text-base font-semibold leading-loose text-accent-red">
            {CurrencyHelpers.formatForCurrency(discountedPrice, locale)}
          </Typography>
        </div>
      ) : (
        <Typography className="text-base font-semibold leading-loose text-primary-black">
          {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
        </Typography>
      )}
    </>
  );
};

export default Prices;
